import { render } from "./HepaticsHomeView.vue?vue&type=template&id=2db433c3"
import script from "./HepaticsHomeView.vue?vue&type=script&lang=js"
export * from "./HepaticsHomeView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__